<template>
    <div>
        <form-tag-input
            v-for="group in groups"
            :key="group.id"
            :id="`eventbrite_ticket_classes-${group.id}`"
            name="eventbrite_ticket_classes"
            :value="value[constants('ticket_classes', group.id)]"
            :data-source="ticketClasses || []"
            :show-all="true"
            :required="true"
            :disabled="disabled"
            @input="save($event, group.id)"
        >
            <template v-slot:label>{{ group.label }}</template>
        </form-tag-input>
    </div>
</template>

<script>
import { misc_utilities } from "@/nibnut/mixins"

import FormTagInput from "@/nibnut/components/Inputs/FormTagInput"

export default {
    name: "EventbriteTicketClassesInput",
    mixins: [misc_utilities],
    components: {
        FormTagInput
    },
    methods: {
        save (value, group_id) {
            const eventbrite_ticket_classes = [...this.value]
            eventbrite_ticket_classes[this.constants("ticket_classes", group_id)] = value
            this.$emit("input", eventbrite_ticket_classes, "eventbrite_ticket_classes")
        }
    },
    computed: {
        groups () {
            return [
                { id: "TICKET_CLASS_PARTICIPANT", label: this.translate("Which Tickets are considered singer registration?") },
                { id: "TICKET_CLASS_SHIRT", label: this.translate("Which Tickets are considered shirt orders?") },
                { id: "TICKET_CLASS_LUNCH", label: this.translate("Which Tickets are considered lunch orders?") },
                { id: "TICKET_CLASS_DINNER", label: this.translate("Which Tickets are considered dinner orders?") }
            ]
        }
    },
    props: {
        ticketClasses: {
            type: Array,
            required: true
        },
        value: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
